interface GraphQueryState {
	graphQuery: unknown
}

const selectGraphQuery = (state: GraphQueryState) => state.graphQuery

export default selectGraphQuery
